let serverHealthy = true;

export function getServerHealthy(): boolean {
  return serverHealthy;
}

export function setServerHealthy(healthy: boolean): void {
  serverHealthy = healthy;
}
